import { render } from "./KindSalesPages.vue?vue&type=template&id=4c00d6d3&lang=true"
import script from "./KindSalesPages.vue?vue&type=script&lang=js"
export * from "./KindSalesPages.vue?vue&type=script&lang=js"

import "./KindSalesPages.vue?vue&type=style&index=0&id=4c00d6d3&lang=css"
script.render = render

export default script